import React from 'react';
import { ProjectPhaseDetail } from '../types';

interface ProjectPhasesDetailProps {
  phases: ProjectPhaseDetail[];
}

const ProjectPhasesDetail: React.FC<ProjectPhasesDetailProps> = ({ phases }) => {
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'completed':
        return '✓';
      case 'in_progress':
        return '⏳';
      case 'pending':
        return '⏸';
      default:
        return '○';
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'completed':
        return '#22c55e';
      case 'in_progress':
        return '#3b82f6';
      case 'pending':
        return '#6b7280';
      default:
        return '#6b7280';
    }
  };

  const getProgressBarColor = (status: string) => {
    switch (status) {
      case 'completed':
        return '#22c55e';
      case 'in_progress':
        return '#3b82f6';
      case 'pending':
        return '#e5e7eb';
      default:
        return '#e5e7eb';
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case 'completed':
        return '100% COMPLETED';
      case 'in_progress':
        return 'CURRENT';
      case 'pending':
        return '0%';
      default:
        return '0%';
    }
  };

  return (
    <div style={{ marginTop: '24px' }}>
      {phases.map((phase, index) => (
        <div
          key={phase.id}
          style={{
            marginBottom: '16px',
            padding: '16px',
            backgroundColor: '#f8f9fa',
            borderRadius: '8px',
            border: '1px solid #e9ecef',
            position: 'relative'
          }}
        >
          {/* Phase Header */}
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
            <div
              style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                backgroundColor: getStatusColor(phase.status),
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: 'bold',
                marginRight: '12px'
              }}
            >
              {getStatusIcon(phase.status)}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: '600', fontSize: '14px', color: '#1f2937' }}>
                Phase {phase.phaseNumber}/5 — {phase.name}
              </div>
              <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>
                {phase.description}
              </div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: '12px', color: '#6b7280' }}>
                {phase.targetDate}
              </div>
              <div
                style={{
                  fontSize: '12px',
                  fontWeight: '600',
                  color: getStatusColor(phase.status),
                  marginTop: '2px'
                }}
              >
                {getStatusText(phase.status)}
              </div>
            </div>
          </div>

          {/* Progress Bar */}
          <div style={{ marginBottom: '8px' }}>
            <div
              style={{
                width: '100%',
                height: '6px',
                backgroundColor: '#e5e7eb',
                borderRadius: '3px',
                overflow: 'hidden'
              }}
            >
              <div
                style={{
                  width: `${phase.progress}%`,
                  height: '100%',
                  backgroundColor: getProgressBarColor(phase.status),
                  borderRadius: '3px',
                  transition: 'width 0.3s ease'
                }}
              />
            </div>
          </div>

          {/* Milestone */}
          {phase.milestone && (
            <div style={{ fontSize: '12px', color: '#4b5563', fontStyle: 'italic' }}>
              Milestone: {phase.milestone}
            </div>
          )}

          {/* Connector line to next phase */}
          {index < phases.length - 1 && (
            <div
              style={{
                position: 'absolute',
                left: '27px',
                bottom: '-16px',
                width: '2px',
                height: '16px',
                backgroundColor: '#e5e7eb'
              }}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default ProjectPhasesDetail; 